import { wpFetch } from 'src/helpers/wpApiHandler';

const useLoginAuth = async ({ setIsLoggedIn, setUser, logInEmail, logInPassword, setFetchingDataLoader }) => {
  try {
    const companyID = await wpFetch(['company_login'], {
      method: 'POST',
      body: {
        company_login: logInEmail,
        company_password: logInPassword,
      },
    });

    const companyData = await wpFetch(['company', companyID], {
      method: 'GET',
    });

    setUser(companyData);
    localStorage.setItem('user', JSON.stringify(companyData));

    setIsLoggedIn(true);
    setFetchingDataLoader(false);
  } catch (error) {
    throw new Error(error.message || 'Login failed');
  }
};
export default useLoginAuth;
